// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quizzes-container {
    display: flex;
    flex-wrap: wrap; /* Allow cards to wrap onto the next line */
    gap: 20px; /* Control the spacing between cards */
  }
  
  .quiz-card {
    position: relative; /* Ensure this container is positioned relative */
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    transition: transform 0.2s;
    box-sizing: border-box;
    padding: 50px;
    height: 392px;
    width: 100%;
    margin-bottom: 20px;
  }
  
  .quiz-card:hover {
    transform: scale(1.05);
  }
  
  .design-1 {
    background-color: #007bff;
    width: 100%;
  }
  
  .design-2 {
    background-color: #ff9800;
    width: calc(55% - 10px); /* Subtracting half of the gap */
  }
  
  .design-3 {
    background-color: #00bcd4;
    width: calc(45% - 10px); /* Subtracting half of the gap */
  }
  
  .quiz-card h2 {
    font-size: 50.4px;
    padding-right: 100px;
    color: #FFF;
    font-family: Georgia;
    font-weight: 700;
    line-height: 120%;
  }
  
  .quiz-card p {
    color: #FFF;
    font-family: Inter;
    font-size: 18.9px;
    font-weight: 400;
    line-height: 150%;
  }
  
  .quiz-button {
    background-color: #e91e63;
    color: #FFF;
    border: none;
    width: 204px;
    height: 64px;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.5px;
    position: absolute;
    bottom: 50px;
  }
  
  .quiz-button:hover {
    background-color: #c2185b;
  }
  
  @media (max-width: 1200px) {
    .quiz-card {
      height: 400px;
      width: 100% !important;
      margin-bottom: 20px;
    }
  
    .quiz-card h2 {
      font-size: 36px;
    }
  
    .quiz-card p {
      font-size: 16px;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/QuizCard/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe,EAAE,2CAA2C;IAC5D,SAAS,EAAE,sCAAsC;EACnD;;EAEA;IACE,kBAAkB,EAAE,iDAAiD;IACrE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,uBAAuB,EAAE,gCAAgC;EAC3D;;EAEA;IACE,yBAAyB;IACzB,uBAAuB,EAAE,gCAAgC;EAC3D;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;IACrB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":[".quizzes-container {\n    display: flex;\n    flex-wrap: wrap; /* Allow cards to wrap onto the next line */\n    gap: 20px; /* Control the spacing between cards */\n  }\n  \n  .quiz-card {\n    position: relative; /* Ensure this container is positioned relative */\n    border-radius: 10px;\n    color: #fff;\n    cursor: pointer;\n    transition: transform 0.2s;\n    box-sizing: border-box;\n    padding: 50px;\n    height: 392px;\n    width: 100%;\n    margin-bottom: 20px;\n  }\n  \n  .quiz-card:hover {\n    transform: scale(1.05);\n  }\n  \n  .design-1 {\n    background-color: #007bff;\n    width: 100%;\n  }\n  \n  .design-2 {\n    background-color: #ff9800;\n    width: calc(55% - 10px); /* Subtracting half of the gap */\n  }\n  \n  .design-3 {\n    background-color: #00bcd4;\n    width: calc(45% - 10px); /* Subtracting half of the gap */\n  }\n  \n  .quiz-card h2 {\n    font-size: 50.4px;\n    padding-right: 100px;\n    color: #FFF;\n    font-family: Georgia;\n    font-weight: 700;\n    line-height: 120%;\n  }\n  \n  .quiz-card p {\n    color: #FFF;\n    font-family: Inter;\n    font-size: 18.9px;\n    font-weight: 400;\n    line-height: 150%;\n  }\n  \n  .quiz-button {\n    background-color: #e91e63;\n    color: #FFF;\n    border: none;\n    width: 204px;\n    height: 64px;\n    border-radius: 5px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    font-family: Inter;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 0.5px;\n    position: absolute;\n    bottom: 50px;\n  }\n  \n  .quiz-button:hover {\n    background-color: #c2185b;\n  }\n  \n  @media (max-width: 1200px) {\n    .quiz-card {\n      height: 400px;\n      width: 100% !important;\n      margin-bottom: 20px;\n    }\n  \n    .quiz-card h2 {\n      font-size: 36px;\n    }\n  \n    .quiz-card p {\n      font-size: 16px;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
